export const getStartYear = (effectiveDate: Date, terminationDate: Date): number => {
  let actualYear = new Date().getFullYear();
  let endYear = new Date(terminationDate).getFullYear();
  let effectiveYear = new Date(effectiveDate).getFullYear();

  if (actualYear < effectiveYear) {
    return effectiveYear;
  }
  else if (endYear > actualYear) {
    return actualYear;
  } else {
    return endYear;
  }
}